<template>
  <div class="inner-content" v-if="screenType == '0'">
    <div class="title">{{ data.title }}</div>
    <div class="page-content">
      <div class="page-leftcontent">
        <div class="swiper-containerFocus">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, innerIndex) in data.picture"
              :key="innerIndex"
            >
              <img :src="'/dsf5' + item.path" class="swiper-img" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div class="page-rightcontent" v-html="data.content"></div>
    </div>
  </div>
  <div v-else class="verticalGraphic">
    <div class="swiper-containerFocus">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in data.picture"
          :key="index"
        >
          <img :src="'/dsf5' + item.path" class="swiper-img" />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="vertical-detail" v-html="data.content"></div>
  </div>
</template>

<script>
export default {
  name: "graphicCampusDynamic",
  data() {
    return {};
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    screenType: {
      type: String,
      default: "1",
    },
  },
  created() {
    this.loadScript(() => {
      this.$nextTick(() => {
        this.initSwiper();
      });
    });
  },
  methods: {
    // 初始化swiper
    async initSwiper() {
      const _this = this;
      this.$nextTick(() => {
        this.mySwiper = new Swiper(".swiper-containerFocus", {
          autoplay: true,
          pagination: {
            el: ".swiper-pagination",
          },
          on: {},
        });
      });
    },
    // 加载js
    loadScript(callback) {
      this.$http
        .importFiles([
          dsf.url.getWebPath("$/js/libs/swiper/swiper-bundle.min.css"),
          dsf.url.getWebPath("$/js/libs/swiper/swiper-bundle.min.js"),
        ])
        .then(() => {
          callback?.();
        })
        .catch(() => {
          dsf.layer.message("加载fabric文件报错", false);
          reject();
        });
    },
  },
};
</script>

<style>
</style>